import React, { Component } from 'react';
import { Field, reduxForm, FormSection } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { InputField } from 'Common/SemanticWrapper';

import { APPLICATION_MEMBER_FORM_NAME } from 'Common/FormEnum';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { IncomeForm } from '../hub/IncomeForm';
import { validateIncome } from '../../helpers/validation/IncomeValidator';
import { TitledCard } from 'Components';

class MemberForm extends Component {
  render() {
    return (
      <Form>
        <TitledCard title={'Information'}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <Field
                  label={'First Name'}
                  component={InputField}
                  name={Fields.FirstName}
                  type={'text'}
                  maxLength={20}
                />
              </Grid.Column>
              <Grid.Column width={5}>
                <Field
                  label={'Last Name'}
                  component={InputField}
                  name={Fields.LastName}
                  type={'text'}
                  maxLength={20}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <FormSection name="Income">
          <IncomeForm memberName={'Member'} />
        </FormSection>
      </Form>
    );
  }
}

const validate = (values, ownProps) => {
  const errors = {};

  if (!values[Fields.FirstName] || values[Fields.FirstName].trim().length < 1) {
    errors[Fields.FirstName] = 'Please enter a first name.';
  }

  if (!values[Fields.LastName] || values[Fields.LastName].trim().length < 1) {
    errors[Fields.LastName] = 'Please enter a last name.';
  }

  errors.Income = validateIncome(values.Income);

  return errors;
};

export default reduxForm({
  validate,
  form: APPLICATION_MEMBER_FORM_NAME,
  enableReinitialize: true,
  destroyOnUnmount: true,
})(MemberForm);



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/member/MemberForm.js